import { DateTime } from 'luxon';

import { anykrowdApi } from '@/api/anykrowdApi';
import useStorageService from '@/shared/composables/useStorageService';

const { get, set } = useStorageService();

// Generate login token
const generateLoginToken = async () => {
	const expiresAt = DateTime.now().plus({ days: 2 }).toISO({ includeOffset: false });
	const { data } = await anykrowdApi.post<{ raw_token: string }>('/login-tokens', { expires_at: expiresAt }, true);

	// Update cache
	const key = 'login-tokens';
	let keys = await get('cachedDataKeys');
	if (!keys) {
		keys = [key];
	} else {
		if (!keys.includes(key)) {
			keys.push(key);
		}
	}
	await set('cachedDataKeys', keys);

	set('login-tokens', data);
};

// Get login token
const getLoginTokenApiCall = async () => {
	// Check if token is expired
	const cachedToken = await get('login-tokens');

	if (cachedToken) {
		const tokenExpiresAt = DateTime.fromISO(cachedToken.expires_at);

		// If token is expired, generate a new one
		if (tokenExpiresAt < DateTime.now()) {
			await generateLoginToken();
		}
	} else {
		// If no token is cached, generate a new one
		await generateLoginToken();
	}
};

// Check if login token is valid
const isLoginTokenValid = async () => {
	const cachedToken = await get('login-tokens');
	if (!cachedToken) {
		return false;
	} else {
		const tokenExpiresAt = DateTime.fromISO(cachedToken.expires_at);
		return tokenExpiresAt > DateTime.now();
	}
};

const useProfileUtils = () => {
	return {
		getLoginTokenApiCall,
		isLoginTokenValid,
	};
};

export default useProfileUtils;
